import {useEffect, useState} from "react";
import DatePicker, {registerLocale} from 'react-datepicker'
import surveys_api from "../api/protected/surveys";
import organisations_api from "../api/protected/organisations";
import teams_api from "../api/protected/teams";
import people_api from "../api/protected/people";
import en from 'date-fns/locale/en-GB';
import types from "../assets/constants/types";
import 'react-datepicker/dist/react-datepicker.css'
import back_arrow from "../assets/backarrow.svg";
import SurveyParticipantsGridContainer from "../containers/SurveyParticipantsGridContainer";
import SurveyUpdateParticipants from "./SurveyUpdateParticipants";
import {useNavigate, useSearchParams} from "react-router-dom";
import SurveyPointPopup from "./SurveyPointPopup";
import GenericDialog from "./GenericDialog";
import info from "../assets/info-icon.png";
import SubscriptionNeededPopup from "../components/SubscriptionNeededPopup";
import profile_api from "../api/protected/profile";
registerLocale('en-gb', en);


const NewSurvey = (props) => {

    const navigate = useNavigate()

    const disabled_date = (surveyDate) => new Date() < surveyDate;
    const [params, setParams] = useSearchParams()

    const [organisations, setOrganisations] = useState([]);
    const [organisationID, setOrganisationID] = useState(0);
    const [teams, setTeams] = useState([]);
    const [teamID, setTeamID] = useState(0);
    const [people, setPeople] = useState([]);
    const [selectedPeople, setSelectedPeople] = useState([]);
    const [surveyPoint, setSurveyPoint] = useState(1);
    const [surveyType, setSurveyType] = useState(1);
    const [surveyExpiry, setSurveyExpiry] = useState(new Date());
    const [newlySelected, setNewlySelected] = useState([])
    const [showPopup, setShowPopup] = useState(false)

    const [subscription, setSubscription] = useState(null);


    const [organisationLoaded, setOrganisationLoaded] = useState(false)
    const [teamLoaded, setTeamLoaded] = useState(false)

    const [showPointWarning, setShowPointWarning] = useState(false)
    const [showSubscriptionPopup, setShowSubscriptionPopup] = useState(false)
    const subscriptionPopupButtons = [{"text":"OK", "id": "1"}, {"text":"Upgrade", "id": "2"}];
    const [subscriptionPopupText, setSubscriptionPopupText] = useState("")

    const [showExpiryHover, setShowExpiryHover] = useState(false)
    const [showConfirmationPopup, setShowConfirmationPopup] = useState(false)
    const confirmationButtons = [{"text":"OK", "id": "1"}];

    useEffect(() => {
        if (params.get('type')) {
            setSurveyPoint(parseInt(params.get("type")))
        } else {
            setSurveyPoint(props.passedPoint)
            props.setPassedPoint(1)
        }

        getOrganisations();

        let default_date = new Date()
        default_date.setDate(default_date.getDate() + 7)
        setSurveyExpiry(default_date)
    }, [])

    useEffect(() => {
        if(!teamID) return;
        if (props.correctPoint) {
            let response = surveys_api.checkSurveyPoint(teamID)
            response.then(response => {
                for(const point_type of response.data) {
                    if(point_type.count === 0) {
                        console.log(point_type)
                        setSurveyPoint(point_type.point)
                        break;
                    }
                }
            })
        }
    }, [teamID]);

    useEffect(() => {
        if(!surveyPoint || !teamID || surveyPoint === 1) return;
        let response = surveys_api.checkSurveyPoint(teamID)
        response.then(response => {
            if(surveyPoint > 1 && surveyPoint < 5) {
                let prev_point_count = response.data[surveyPoint - 2].count
                if(!prev_point_count) setShowPointWarning(true)
            }
        }).catch(err => console.log(err))
    }, [surveyPoint]);

    useEffect(() => {
        if(!organisationLoaded || !organisations.length) return;
        if (params.get('organisation')) {
            setOrganisationID(parseInt(params.get('organisation')))
        } else {
            getTeams()
        }
    }, [organisationLoaded, organisations])

    useEffect(() => {
        if (!organisationID) return;
        getTeams();
    }, [organisationID]);

    useEffect(() => {
        if(!teamLoaded || !teams.length) return;
        if (params.get('team')) {
            setTeamID(parseInt(params.get('team')))
        }
    }, [teamLoaded, teams]);

    useEffect(() => {
        if (!teamID) return;
        getPeople();
    }, [teamID])

    const clearParams = () => {
        setParams({})
    }

    const getOrganisations = () => {
        let response = organisations_api.getOrganisations();
        response.then(response => {
            setOrganisations(response.data.organisations);
        }).finally(() => {
            setOrganisationLoaded(true);
        })
    }

    const getTeams = () => {
        let response = teams_api.getTeamsByOrganisationID(organisationID);
        response.then(response => {
            setTeams(response.data.teams)
        }).finally(() => {
            setTeamLoaded(true)
        })
    }

    const getPeople = () => {
        let response = people_api.getPeople(teamID);
        response.then(response => {
            setPeople(response.data.people)
        }).finally(() => {
            clearParams()
        })
    }

    const createSurvey = (is_draft=false) => {
        let body = {
            "survey_type": surveyType,
            "survey_point": surveyPoint,
            "organisation_id": organisationID,
            "team_id": teamID,
            "name": "survey",
            "expiry_date": Math.trunc(surveyExpiry.getTime()/1000),
            "participants": selectedPeople,
            "is_draft": is_draft
        }

        let response = surveys_api.newSurvey(body);
        response.then(response => {
            if(is_draft) {
                navigate(`/surveys/${response.data.survey_id}`)
            } else {
                setShowConfirmationPopup(true)
            }
        }).catch(err => {
            if (err.response.request.status === 402) {
                if (err.response.data.title.includes("type")) {
                    setSubscriptionPopupText("Bronze subscriptions are unable to issue full type surveys. Please upgrade your subscription if you wish to use these")
                } else if (err.response.data.title.includes("point")) {
                    setSubscriptionPopupText("Bronze subscriptions are unable to issue post review surveys. Please upgrade your subscription if you wish to use these")
                }
                setShowSubscriptionPopup(true)
            }
            console.log(err)
        })
    }

    const handleConfirmationResult = (button_id) => {
        if(!button_id) return;
        props.updateSurveysGrid()
    }

    const handleNewlySelected = (result) => {
        if (!result) return;
        if (result === "1") {
            createSurvey();
        } else if (result === "2") {
            createSurvey(true)
        }
        setShowPopup(false)
    }

    const submitController = (ev) => {
        ev.preventDefault();
        if (newlySelected.length === 0) {
            createSurvey();
        } else {
            setShowPopup(true)
        }
    }

    const validateSubmit = () => {
        return (!surveyType || !surveyPoint || !organisationID || !teamID);
    }

    const closePointPopup = (ev) => {
        if(!ev) return;
        setShowPointWarning(false)
    }

    const handlePointCancel = (ev) => {
        if(!ev) return;
        setSurveyPoint(1);
        setShowPointWarning(false);
    }

    const handleSubscriptionPopupResult = (res) => {
        if(!res) return;
        if (res === "1") {
            setShowSubscriptionPopup(false)
        } else {
            navigate("/pricing-plans")
        }
    }

    const handleSurveyTypeChange = (ev) => {
        const selectedValue = parseInt(ev.target.value);

        if (selectedValue === 1 && subscription < 1) {
            setShowSubscriptionPopup(true);
            return;
        }

        setSurveyType(selectedValue);
    };

    const getSubscription = () => {
        let response = profile_api.getSubscription();
        response.then(response => {
            setSubscription(response.data.subscription.type);
        }).catch(() => {});
    };

    useEffect(() => {
        getSubscription();
    }, []);

    useEffect(() => {
        if (subscription < 1 && subscription != null) {
            setSurveyType(2);
        }
    }, [subscription]);

    return (
        <>
            <div className="back-link link" onClick={() => props.updateSurveysGrid()}>
                <img className={"back-arrow-classname"} src={back_arrow} alt="Back Arrow"/>
            </div>
            <div className="surveys-page-header">
                <div className="surveys-page-title">Create a new survey</div>
            </div>
            <div className="survey-form-container">
                <div className="survey-form-title">Survey Details</div>
                <div className="field-input">
                    <div className="field-input-entry">
                        <div className="label">Organisation</div>
                        <select onChange={ev => setOrganisationID(parseInt(ev.target.value))} value={organisationID}>
                            <option value={0} key={0} disabled hidden/>
                            {organisations && organisations.map((organisation, idx) => {
                                return <option value={organisation.id} key={idx + 1}>{organisation.name}</option>
                            })}
                        </select>
                    </div>
                </div>
                <div className="field-input">
                    <div className="field-input-entry">
                        <div className="label">Team</div>
                        <select onChange={ev => setTeamID(parseInt(ev.target.value))} value={teamID} disabled={organisationID === 0}>
                            <option value={0} key={0} disabled hidden/>
                            {teams && teams.map((team, idx) => {
                                return <option value={team.id} key={idx + 1}>{team.name}</option>
                            })}
                        </select>
                    </div>
                </div>
                <div className="field-input">
                    <div className="field-input-entry">
                        <div className="label">Survey Point</div>
                        <select onChange={ev => setSurveyPoint(parseInt(ev.target.value))} value={surveyPoint}>
                            {types.point_types && types.point_types.map((surveyPoint, idx) => {
                                return <option value={surveyPoint.id} key={idx}>{surveyPoint.name}</option>
                            })}
                        </select>
                    </div>
                </div>
                <div className="field-input">
                    <div className="field-input-entry">
                        <div className="label">Survey Type</div>
                        <select onChange={handleSurveyTypeChange} value={surveyType}>
                            {types.survey_types && types.survey_types.map((surveyType, idx) => {
                                return <option value={surveyType.id} key={idx}>{surveyType.name}</option>
                            })}
                        </select>
                    </div>
                </div>
                <div className="field-input">
                    <div className="field-input-entry">
                        <div className="label info-popup">
                            Survey Expiration Date
                            <img src={info} alt="Info"
                                 onMouseOver={() => setShowExpiryHover(true)}
                                 onMouseLeave={() => setShowExpiryHover(false)}
                            />
                            {showExpiryHover ?
                                <div className="dashboard-roi-title-hover" style={{top: 37, left: 151}}>
                                    <div className="dashboard-roi-title-hover-triangle-outer">
                                        <div className="dashboard-roi-title-hover-triangle-inner"/>
                                    </div>
                                    <div className="dashboard-roi-title-hover-text regular">
                                        This is the deadline for survey completion which is included in the survey
                                        invitation emails and reports. We recommend at least a week for completions.
                                        Note: This is for information only and does not prevent later responses.
                                    </div>
                                </div> : null
                            }
                        </div>
                        <DatePicker dateFormat="dd/MM/yyyy" locale="en-gb" filterDate={disabled_date}
                                    selected={surveyExpiry} onChange={(date) => setSurveyExpiry(date)}
                        />
                    </div>
                </div>
            </div>
            <div className="survey-form-container">
                <div className="survey-form-title blue">Team Members & Stakeholders to be included in this survey</div>
                <SurveyParticipantsGridContainer people={people} selectedPeople={selectedPeople}
                                                 updateSelected={setSelectedPeople.bind(this)} isNew={true}
                                                 newlySelected={newlySelected}
                                                 updateNewlySelected={setNewlySelected.bind(this)}/>
                <div className="field-input flexed">
                    <button className={`update-organisation-button link ${validateSubmit() ? "disabled" : ""}`}
                            onClick={() => createSurvey(true)} disabled={validateSubmit()}>
                        SAVE DRAFT
                    </button>
                    <button className={`update-organisation-button link ${validateSubmit() ? "disabled" : ""}`}
                            onClick={submitController} disabled={validateSubmit()}>
                        REVIEW AND ISSUE SURVEY
                    </button>
                    <button className="update-organisation-button link" onClick={() => navigate(`/teams/${teamID}`)}>
                        SEE TEAM PAGE
                    </button>
                </div>
                {showPopup ?
                    <SurveyUpdateParticipants people={newlySelected} result={handleNewlySelected.bind(this)}
                                              cancel_text="Cancel"
                    /> : null
                }
            </div>
            {showPointWarning ?
                <SurveyPointPopup point={surveyPoint} acceptNewSurvey={closePointPopup.bind(this)}
                                  cancelNewSurvey={handlePointCancel.bind(this)}
                                  closePopup={closePointPopup.bind(this)}
                /> : null
            }
            {showSubscriptionPopup ?
                <SubscriptionNeededPopup
                    onClose={() => setShowSubscriptionPopup(false)}
                /> : null
            }
            {showConfirmationPopup ?
                <GenericDialog title="Success"
                               text="Thank you. These survey invitations have been sent"
                               buttons={confirmationButtons}
                               result={handleConfirmationResult.bind(this)}
                /> : null
            }
        </>
    )
}

export default NewSurvey;
